import { ListProps } from "antd";
import { UseControlMedico } from "hooks/ControlMedicoHook";
import {
  IPermisos,
  ListaGenerica,
  ListaProps,
  MasterCentroCostoProps,
} from "models/General";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

interface ListContextType {
  tipoCertificado: ListaProps[];
  tipoResultado: ListaProps[];
  centroCosto: ListaProps[];
  centroCostoMaster: MasterCentroCostoProps[];
  clinica: ListaProps[];
  diagnosticoOIT: ListaProps[];
  formatos: ListaProps[];
  tipoExamen: ListaProps[];
  permisos: IPermisos;
}

const ListContext = createContext<ListContextType | undefined>(undefined);

const ListProvider = ({ children }: { children: ReactNode }) => {
  const [tipoCertificado, setTipoCertificado] = useState<ListaProps[]>([]);
  const [tipoResultado, setTipoResultado] = useState<ListaProps[]>([]);
  const [centroCosto, setCentroCosto] = useState<ListaProps[]>([]);
  const [centroCostoMaster, setCentroCostoMaster] = useState<
    MasterCentroCostoProps[]
  >([]);
  const [clinica, setClinica] = useState([]);
  const [diagnosticoOIT, setDiagnosticoOIT] = useState<ListaProps[]>([]);
  const [formatos, setFormatos] = useState<ListaProps[]>([]);
  const [tipoExamen, setTipoExamen] = useState<ListaProps[]>([]);
  const [permisos, setPermisos] = useState<IPermisos>({
    ANULAR_EMO: false,
    ANULAR_PROGRAMACION: false,
    EDITAR_EMO: false,
    REGISTRAR_EMO: false,
    REGISTRAR_INASISTENCIA: false,
    EDITAR_CLINICA: false,
  });

  const { cargaInicial } = UseControlMedico();
  useEffect(() => {
    cargaInicial().then((response) => {
      if (response.status) {
        const _centroCosto: ListaProps[] = response.centroCosto.map(
          (item: any) => {
            return {
              value: item?.ID_CENTRO_COSTO,
              label: item?.COLOQUIAL,
            };
          }
        );
        setCentroCostoMaster(response.centroCosto);
        setTipoCertificado(response.tipoCertificado);
        setTipoResultado(response.tipoResultado);
        setCentroCosto(_centroCosto);
        setClinica(response.clinica);
        setDiagnosticoOIT(response.diagnostico_oit);
        setFormatos(response.formatos);
        setTipoExamen(response.tipoExamen);
        setPermisos(response.permisos);
      }
    });
  }, []);

  const value = {
    tipoCertificado,
    tipoResultado,
    centroCosto,
    centroCostoMaster,
    clinica,
    diagnosticoOIT,
    formatos,
    permisos,
    tipoExamen,
  };

  return <ListContext.Provider value={value}>{children}</ListContext.Provider>;
};

// Hook para usar el contexto
const useList = () => {
  const context = useContext(ListContext);
  if (!context) {
    throw new Error("error  fuera del contexto");
  }
  return context;
};

export { ListProvider, useList };
